import axios from "axios";

// Create an axios instance with predefined headers and settings.
const axiosInstance = axios.create({
  //   headers: {
  //     "x-site-id": Config.SITE_ID,
  //     Authorization: `Bearer ${Config.Token}`,
  //   },
  baseURL: "https://ecommv2.servingintel.com",
  maxBodyLength: Infinity,
});

  const siteId = process.env.REACT_APP_SITE_ID;
  const serverId = process.env.REACT_APP_SERVER_ID;

export const loginPin = async (pin: string): Promise<any> => {
  
  try {
    // Note how the URL is now simplified
    const response = await axiosInstance.post(
      `customer/login-si180-pin/${serverId}/${siteId}`,
      {
        pin,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Login error:", error);
    throw error;
  }
};

export const fetchCustomer= async (q: string): Promise<any> => {
  try {
    const response = await axiosInstance.get(`/customer/lookup-customer/${serverId}/${siteId}/${q}`);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchMenu= async (): Promise<any> => {
  try {
    const response = await axiosInstance.get(`/items/menu/${serverId}/${siteId}`);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchMenuCategories= async (): Promise<any> => {
  try {
    const response = await axiosInstance.get(`/items/menu-categories/${serverId}/${siteId}/${sessionStorage.getItem("selectedMenu")}`);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchCategoryItems= async (): Promise<any> => {
  try {
    const response = await axiosInstance.get(`/items/category-items/${serverId}/${siteId}/${sessionStorage.getItem("selectedMenu")}/${sessionStorage.getItem("selectedCategory")}/${sessionStorage.getItem("selectedOrderOption")}`);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const searchItems= async (keyWord): Promise<any> => {
  try {
    const trimmedKeyword = keyWord.trim();
    const response = await axiosInstance.get(`/items/search-items/${serverId}/${siteId}/${trimmedKeyword}`);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchTableLocation= async (): Promise<any> => {
  try {
    const response = await axiosInstance.get(`/customer/tables/${serverId}/${siteId}`);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchItemMods= async (id: string): Promise<any> => {
  try {
    const response = await axiosInstance.get(`/items/mods/${siteId}/${id}?server_id=${serverId}`);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
